import styled from 'styled-components';

export default styled.div`
	display: flex;
	gap: var(--spacing-medium-large);
	align-items: flex-start;
	button {
		font-weight: 700;
		flex-shrink: 0;
		padding: 0.4rem;
		height: 5rem;
	}

	.add-contact-link {
		&:hover,
		&:focus,
		&:active {
			border-bottom: 0px;
		}
	}

	.add-contact-link.motif-text-button-disabled:hover {
		cursor: default;
		border-bottom: 0px;
	}
`;
